<script setup>
import { useTranslation, } from '@/assets/js/src/util/composables'
const { t, } = useTranslation()
</script>

<template>
    <div>
        <h2 class="mt-5 mb-2">
            {{ t('async.webmasters.wordpress.heading') }}
        </h2>
        <div v-html="t('async.webmasters.wordpress.text')"></div>
    </div>
</template>
